/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Button, Radio, Modal, Input, Form, Col, Row, Typography, notification } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { checkinUser, userAwbLogout } from '../../../actions/userAWB';
import {
  IMP_WEB_CHK_UPD_PAYMENT_MODE,
  IMP_WEB_CHK_CHK_PAID,
  updateOrderId,
  IMP_WEB_CHK_PAID_ALL_INVOICE,
} from '../../../config/apiConfig';
import { payWithoutOTP } from '../../../config/checkinApi';
import { setPaymentInfo } from './../../../actions/payment';
import { TcbCheckPayment, TcbGetQR } from '../../../config/tcbQrPayment';
import { useRef } from 'react';
import { IMP_PFX } from '../../../config/Constant';
import QRCode from 'qrcode.react';
const { TextArea } = Input;

const ModalSelectMethod = ({
  visible,
  data,
  setVisible,
  loading,
  setLoading,
  isHawb,
  setHasData,
  loadData,
}) => {
  const [visibleConfirm, setVisibleConfirm] = useState(false);
  const { token } = useSelector((state) => state.userAwb.dataCheckin);
  const webTrachToken = useSelector((state) => state.userAwb.dataLogin.token);
  const dispatch = useDispatch();
  const history = useHistory();
  const [transferSyntax, setTransferSyntax] = useState('');
  const [form] = useForm();
  const [qrModalVisible, setQrModalVisible] = useState(false);
  const [qrResult, setQrResult] = useState(null);
  const [expiresTime, setExpiresTime] = useState({days: 0, hours: 0, minutes: 10, seconds: 0});
  const [paymentStatus, setPaymentStatus] = useState('PENDING');
  const [selectedMethod, setSelectedMethod] = useState('WEB');

  const checkExtend = useRef(30); // số lần check trạng thái thanh toán còn lại
  const holdCheckPayment = useRef(false); // biến giữ trạng thái đang check thanh toán
  const checkCountdown = useRef(true); // biến giữ trạng thái countdown

  useEffect(() => {
    if (!qrResult?.order_information?.order_duration) {
      return;
    }
    const duration = qrResult.order_information.order_duration;
    // Giả sử duration có định dạng "30"
    // countdown từ duration phút
    let totalSeconds = parseInt(duration) * 60;
    const interval = setInterval(() => {
      checkCountdown.current = true;
      const days = Math.floor(totalSeconds / (24 * 3600));
      const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      setExpiresTime({ days, hours, minutes, seconds });
      if (totalSeconds <= 0) {
        checkExtend.current = 30;
        checkCountdown.current = false;
        clearInterval(interval);
        notification.info({
          message: 'Mã QR đã hết hạn. Vui lòng thử lại!',
        });
      }
      totalSeconds--;
    }, 1000);

    // check payment
    const checkQRConfirm = async () => {
      if (!qrResult || !qrResult.transaction_log_id) {
        notification.error({
          message: 'Lỗi khi kiểm tra trạng thái thanh toán! Vui lòng thử lại!',
        });
        clearInterval(backgoundSyncInterval);
        return;
      }
      const inputRequest = {
        transactionLogId: qrResult.transaction_log_id,
      };
      try {
        if (checkExtend.current <= 0) {
          clearInterval(backgoundSyncInterval);
          setQrModalVisible(false);
          notification.info({
            message: 'Mã QR đã hết hạn. Vui lòng thử lại!',
          });
          return;
        }
        if (!checkCountdown.current) {
          checkExtend.current = checkExtend.current - 1;
        }
        if (holdCheckPayment.current) {
          return;
        }
        holdCheckPayment.current = true;
        var result = await TcbCheckPayment(inputRequest, isHawb ? webTrachToken : token);
        if (result.data) {
          setPaymentStatus(result.data.transaction_status?.toLocaleUpperCase());
          if (result.data.transaction_status?.toLocaleUpperCase() === 'SUCCESS') {
            // const updateOrderIdRes = await updateOrderId(
            //   {
            //     ...data,
            //     WEB_PMT_MOD: 'WQR',
            //     SND_PAY_STR: transferSyntax,
            //     RCV_BNK_TRS_CD1: qrResult.transaction_log_id,
            //   },
            //   isHawb ? webTrachToken : token
            // );
            var updateOrderIdRes = await IMP_WEB_CHK_PAID_ALL_INVOICE(
              {
                ...data,
                WEB_PMT_MOD: 'WQR',
                SND_PAY_STR: transferSyntax,
                RCV_DAT: result.data.processing_date ?? moment().format('YYYY/MM/DD HH:mm:ss'),
                RCV_BNK_AMT: result.data.transaction_amount,
                RCV_BNK_TRS_COD: result.data.destination_account_number,
                COD_CUR: result.data.currency,
                SND_PAY_DAT: result.data.created_date,
                BNK_COD: `${qrResult.transaction_log_id}#${data.TABLE_ID}#${result.data.transaction_status}#`,
                RCV_BNK_STR: result.data.payment_description,
                BNK_NAM: result.data.sender_account_name,
              },
              isHawb ? webTrachToken : token
            );
            if (updateOrderIdRes.data) {
              await loadData();
              setQrModalVisible(false);
              notification.success({
                message: 'Thanh toán thành công!',
              });
              clearInterval(backgoundSyncInterval);
              setHasData(false);
              setVisible(false);
            } else {
              notification.error({
                message: 'Lỗi khi kiểm tra trạng thái thanh toán! Vui lòng thử lại!',
              });
              clearInterval(backgoundSyncInterval);
              setHasData(false);
            }
          }
        } else {
          console.log('Chưa thanh toán: ', result.data);
        }
        holdCheckPayment.current = false;
      } catch (error) {
        console.log(error);
        return;
      }
    };
    // sau 3s kiểm tra trạng thái thanh toán
    const backgoundSyncInterval = setInterval(() => {
      checkQRConfirm();
    }, 3 * 1000); // 3s

    return () => {
      clearInterval(interval);
      clearInterval(backgoundSyncInterval);
    };
  }, [qrResult, transferSyntax]);

  useEffect(() => {
      const checkPaymentStatus = async () => {
        if (
          !data?.RCV_BNK_TRS_CD1 ||
          !data?.WEB_PMT_MOD !== 'WQR' ||
          ['FN', 'OK'].includes(data?.COD_STS)
        ) {
          return;
        }
        try {
          const inputRequest = {
            transactionLogId: data.RCV_BNK_TRS_CD1,
          };
          var result = await TcbCheckPayment(inputRequest, isHawb ? webTrachToken : token);
          if (result.data) {
            if (result.data.transaction_status?.toLocaleUpperCase() === 'SUCCESS') {
              await IMP_WEB_CHK_PAID_ALL_INVOICE({
                ...data,
                WEB_PMT_MOD: 'WQR',
                SND_PAY_STR: `KHACH HANG ${data.CNE_CODE} THANH TOAN ${data.AMT_CSH_INV} VND TIEN DICH VU THEO DON HANG SO ${data.TABLE_ID}`,
                RCV_DAT: result.data.processing_date ?? moment().format('YYYY/MM/DD HH:mm:ss'),
                RCV_BNK_AMT: result.data.transaction_amount,
                RCV_BNK_TRS_COD: result.data.destination_account_number,
                COD_CUR: result.data.currency,
                SND_PAY_DAT: result.data.created_date,
                BNK_COD: `${data.RCV_BNK_TRS_CD1}#${data.TABLE_ID}#${result.data.transaction_status}#`,
                RCV_BNK_STR: result.data.payment_description,
                BNK_NAM: result.data.sender_account_name,
              });
            }
          }
        } catch (error) {}
      };
  
      checkPaymentStatus();
      // eslint-disable-next-line
    }, [data]);

  const handleOk = async () => {
    if (form.getFieldValue('method') === '') {
      notification.warning({
        message: 'Vui lòng chọn phương thức thanh toán!',
        style: { marginRight: '-50%' },
      });
    } else
      try {
        setLoading(true);
        const payMethod = form.getFieldValue('method');
        // cập nhật phương thức thanh toán
        const updateMethodRes = await IMP_WEB_CHK_UPD_PAYMENT_MODE(
          {
            ...data,
            WEB_PMT_MOD: form.getFieldValue('method'),
            SND_PAY_STR: transferSyntax,
          },
          isHawb ? webTrachToken : token
        );
        
        if (form.getFieldValue('method') === 'WCR') {
          const checkPaidRes = await IMP_WEB_CHK_CHK_PAID(
            {
              ...updateMethodRes.data.P_CURR_OBJ_CHK,
            },
            isHawb ? webTrachToken : token
          );
          if (checkPaidRes.data === 'OK') {
            await IMP_WEB_CHK_PAID_ALL_INVOICE(
              {
                ...data,
              },
              isHawb ? webTrachToken : token
            );
          }
          loadData();
        }
        if (form.getFieldValue('method') === 'WEB') {
          const payRes = await payWithoutOTP(
            data.AMT_CSH_INV,
            'VND',
            data.TABLE_ID,
            transferSyntax,
            isHawb ? webTrachToken : token
          );
          if (payRes.status === 200 && payRes.data) {
            dispatch(
              setPaymentInfo({
                ...payRes.data,
                orderRef: transferSyntax,
                isHawb: isHawb,
              })
            );
            localStorage.setItem(
              'pInfo',
              JSON.stringify({
                ...payRes.data,
                orderRef: transferSyntax,
                isHawb: isHawb,
              })
            );
            const updateOrderIdRes = await updateOrderId(
              {
                ...data,
                RCV_BNK_TRS_CD1: payRes.data.order.id,
              },
              isHawb ? webTrachToken : token
            );
            if (updateOrderIdRes.data) {
              notification.success({
                message: 'Đã cập nhật phương thức thanh toán!',
                style: { marginRight: '-50%' },
              });
              setHasData(true);
              history.push(`/napas/checkout`);
            } else {
              notification.error({
                message: 'Lỗi! Vui lòng thử lại!',
                style: { marginRight: '-50%' },
              });
              setHasData(false);
            }
          }
        }
        if (payMethod === 'WQR') {
          // Handle WQR payment method
          var qrCodeData = {
            orderID: `${IMP_PFX}${data.TABLE_ID.toString()}`,
            amount: data.AMT_CSH_INV,
            currency: 'VND',
            orderDescription: transferSyntax,
            orderNarrative: `WQRCSI ${data.CNE_CODE} P${data.TABLE_ID}`,
          };
          var tokenToUse = isHawb ? webTrachToken : token;
          const qrCodeRes = await TcbGetQR(qrCodeData, tokenToUse);
          if (qrCodeRes.status === 200 && qrCodeRes.data) {
            await updateOrderId(
              {
                ...data,
                WEB_PMT_MOD: 'WQR',
                SND_PAY_STR: transferSyntax,
                RCV_BNK_TRS_CD1: qrCodeRes.data.transaction_log_id,
              },
              isHawb ? webTrachToken : token
            );
            setQrModalVisible(true);
            setQrResult(qrCodeRes.data);
          } else {
            notification.error({
              message: 'Lỗi khi lấy mã QR! Vui lòng thử lại!',
            });
          }
          setLoading(false);
        }
      } catch (error) {
        if (error.response.status === 401) {
          notification.error({
            style: { marginRight: '-50%' },
            message: t('home.sessionNoti'),
          });

          dispatch(checkinUser({}));
          dispatch(setPaymentInfo(undefined));
          dispatch(userAwbLogout());
          localStorage.removeItem('userAWB');
          localStorage.removeItem('checkin');
          localStorage.removeItem('pInfo');
          history.push('/');
        } else if (error.response.error) {
          notification.error({
            message: error.response.error,
            style: { marginRight: '-50%' },
          });
          loadData();
        } else
          notification.error({
            message: 'Lỗi! Vui lòng refresh trang để thử lại!',
            style: { marginRight: '-50%' },
          });
        console.log(error);
      } finally {
        setVisibleConfirm(false);
        if (form.getFieldValue('method') !== 'WQR') 
        {
          setVisible(false);
        }
      }
  };

  const handleCancelQrModal = () => {
    if (paymentStatus !== 'SUCCESS') {
      Modal.confirm({
        title: 'Xác nhận',
        content: 'Giao dịch chưa hoàn tất. Bạn có chắc chắn muốn đóng?',
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        onOk: () => {
          setQrModalVisible(false);
        },
      });
      return;
    }
    setQrModalVisible(false);
  };

  const sendFeedBack = (e) => {
    setSelectedMethod(e.target.value);
    switch (e.target.value) {
      case 'WCR':
        form.setFieldsValue({
          feedback: `Trước giờ đăng ký nhận hàng, quý khách chuyển số tiền ${data.AMT_CSH_INV.toString().replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )} VND đến một trong các tài khoản ngân hàng sau:
          - Tên đơn vị thụ hưởng: CÔNG TY CỔ PHẦN DỊCH VỤ HÀNG HÓA TÂN SƠN NHẤT  

          - Ngân hàng Techcombank - Chi nhánh Gia Định, TP. HCM
                  Số tài khoản: 11610600289017 (VND)
          - Ngân hàng Vietcombank – Chi nhánh TP. HCM
                  Số tài khoản: 0071000028829 (VND)
          - Ngân hàng VP Bank – Chi nhánh TP. HCM
                  Số tài khoản: 73975174 (VND)
          - Ngân hàng VIETTIN BANK – Chi nhánh TP. HCM
                  Số tài khoản: 113600113399 (VND)
                  
          - Nội dung thanh toán: KHACH HANG ${data.CNE_CODE} THANH TOAN ${data.AMT_CSH_INV} VND TIEN DICH VU THEO DON HANG SO ${data.TABLE_ID}`,
        });
        setTransferSyntax(
          `KHACH HANG ${data.CNE_CODE} THANH TOAN ${data.AMT_CSH_INV} VND TIEN DICH VU THEO DON HANG SO ${data.TABLE_ID}`
        );
        break;
      case 'WQR':
        form.setFieldsValue({
          feedback: `Quý khách thanh toán trực tuyến bằng cách quét mã QR`,
        });
        setTransferSyntax(`KHACH HANG ${data.CNE_CODE} THANH TOAN ${data.AMT_CSH_INV} VND TIEN DICH VU THEO DON HANG SO ${data.TABLE_ID}`);
        break;
      case 'WEB':
        form.setFieldsValue({
          feedback: `Quý khách thanh toán trực tiếp bằng thẻ ATM nội địa`,
        });
        setTransferSyntax(
          `KHACH HANG ${data.CNE_CODE} THANH TOAN ${data.AMT_CSH_INV} VND TIEN DICH VU THEO DON HANG SO ${data.TABLE_ID}`
        );
        break;
      default:
        form.setFieldsValue({ feedback: 'Hãy chọn 1 hình thức thanh toán!' });
        setTransferSyntax('');

        break;
    }
  };
  const showData = () => {
    if (data !== undefined) {
      form.setFieldsValue({
        AMT_GRS: data.AMT_GRS.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        AMT_TAX: data.AMT_TAX.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        AMT_TOT: data.AMT_TOT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        AMT_CSH_INV: data.AMT_CSH_INV.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        AMT_CDT_INV: data.AMT_CDT_INV.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        AMT_PRO_INV: data.AMT_PRO_INV.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      });
    }
  };
  useEffect(() => {
    showData();
  }, [data]);
  /*   const allowATMList = [
    "00000233",
    "00000498",
    "00008517",
    "00004414",
    "00021003",
    "00008288",
    "00005922",
    "00005977",
    "00004395",
    "00006026",
    "00008695",
    "00008506",
    "00005976",
    "00001132",
    "00005931",
    "00019946",
    "00005930",
  ]; */
  return (
    <Modal
      className="header-bold background-gray"
      title="Chọn phương thức thanh toán"
      width={1000}
      centered
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[<></>]}>
      <Form
        initialValues={{
          feedback: 'Hãy chọn 1 hình thức thanh toán!',
          method: '',
        }}
        onFinish={() => setVisibleConfirm(true)}
        form={form}
        layout="vertical"
        autoComplete="off">
        <Row gutter={[5, 0]}>
          <Col md={3} span={24}>
            <Form.Item name="AMT_GRS" label="Số tiền DV">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col md={3} span={24}>
            <Form.Item name="AMT_TAX" label="Tiền VAT">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col md={3} span={24}>
            <Form.Item name="AMT_TOT" label="Tổng">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col md={3} span={24}>
            <Form.Item name="AMT_CSH_INV" label="Tiền mặt">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col md={3} span={24}>
            <Form.Item name="AMT_CDT_INV" label="Chuyển khoản">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col md={3} span={24}>
            <Form.Item name="AMT_PRO_INV" label="Ghi nợ">
              <Input readOnly />
            </Form.Item>
          </Col>
          <Col
            style={{
              paddingTop: '3px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            md={3}
            span={24}>
            <Form.Item label=" ">
              <Button
                htmlType="submit"
                style={{ width: '80px' }}
                type="primary"
                loading={loading}
                /*                 disabled={!allowATMList.includes(data.CNE_CODE) && !isHawb}
                 */
              >
                OK
              </Button>
            </Form.Item>
          </Col>
          <Col style={{ paddingTop: '3px' }} md={3} span={24}>
            <Form.Item label=" ">
              <Button onClick={() => setVisible(false)} style={{ width: '80px' }}>
                Hủy
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="method" 
          label="Quý khách có thể thanh toán bằng hình thức quét mã QR hoặc bằng thẻ ATM" 
          style={{ paddingTop: 10, color: '#ffa401', fontWeight: 'bold' }}
        >
          <Radio.Group
            onChange={sendFeedBack}
            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Radio value="WCR">
              Thanh toán bằng chuyển khoản
            </Radio>
            <Radio value="WQR">
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
                <img
                  src="../../../img/qr-payment-logo.png"
                  alt="credit"
                  style={{ width: 40, height: 40 }}
                />
                <p>Thanh toán bằng QR Code</p>
              </div>
            </Radio>
            <Radio value="WEB">
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
                <img
                  src="../../../img/napas-logo.jpg"
                  alt="credit"
                  style={{ width: 80 }}
                />
                <p>Thanh toán bằng thẻ ATM nội địa</p>
              </div>
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="feedback">
          <TextArea rows={5} readOnly></TextArea>
        </Form.Item>
        <Typography
          style={{
            color: 'red',
            fontWeight: 'bold',
            marginTop: '-15px',
            fontSize: '16px',
          }}>
          {transferSyntax}
        </Typography>
        {selectedMethod === 'WCR' && (
          <div>
            <QRCode value={transferSyntax} size={128} />
          </div>
        )}
      </Form>
      <Modal
        centered
        width={'620px'}
        title={'Thông báo'}
        visible={visibleConfirm}
        confirmLoading={loading}
        onCancel={() => setVisibleConfirm(false)}
        footer={[
          <Button onClick={() => setVisibleConfirm(false)}>Không</Button>,
          <Button loading={loading} onClick={handleOk} type="primary">
            Đồng ý
          </Button>,
        ]}>
        Bạn có đồng ý chọn phương thức này?
      </Modal>
      {qrModalVisible && (
        <Modal
          centered
          width={'400px'}
          title={'Thanh toán'}
          visible={qrModalVisible}
          onCancel={handleCancelQrModal}
          footer={[
            <Button disabled={paymentStatus !== 'SUCCESS'} onClick={handleCancelQrModal}>
              Đóng
            </Button>,
          ]}>
          {paymentStatus === 'SUCCESS' ? (
            <div>
              <h2 style={{ color: 'green' }}>Thanh toán thành công!</h2>
              <h3 style={{ color: 'green' }}>
                Hệ thống đang hoàn tất các bước xử lý, vui lòng chờ trong giây lát!
              </h3>
            </div>
          ) : (
            <>
              <h2 style={{ color: '#ffa401' }}>Vui lòng quét mã QR để thanh toán</h2>
              {expiresTime.minutes === 0 && expiresTime.seconds === 0 ? (
                <h3 style={{ color: 'red' }}>Mã QR đã hết hạn. Vui lòng thử lại!</h3>
              ) : (
                <h3 style={{ color: 'red' }}>
                  Mã QR sẽ hết hạn sau: {`${expiresTime.minutes} phút ${expiresTime.seconds} giây`}
                </h3>
              )}
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* HIển thị hình ảnh qr từ base64 */}
                {qrResult && (
                  <img
                    src={`data:image/png;base64,${qrResult?.order_information?.tqr_code_base64}`}
                    alt="QR Code"
                    width={300}
                    height={300}
                  />
                )}
              </div>
              <h3 style={{ color: 'red' }}>
                Vui lòng giữ màn hình mở cho đến khi giao dịch hoàn tất.
              </h3>
            </>
          )}
        </Modal>
      )}
    </Modal>
  );
};
export default ModalSelectMethod;
